// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const copperajah_gmax: PokeData = {
  "id": 10224,
  "name": "copperajah-gmax",
  "height": 230,
  "weight": 10000,
  "base_experience": 175,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [],
  "moves": [
    "behemoth-bash",
    "metal-claw",
    "metal-burst",
    "scrap-throw",
    "metal-sound",
    "steel-beam",
    "smart-strike",
    "meteor-mash",
    "magnet-bomb"
  ],
  "evolution_chain": {
    "id": 460,
    "item": null,
    "species": [
      {
        "name": "cufant",
        "order": 878,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "copperajah",
        "order": 879,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 878,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 150,
    "speed": 47,
    "ability_power": 204
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
